export default __webpack_public_path__ + "static/media/TITAN-IRON.88b3ed11.png";